import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { registerPushServiceWorker } from './services/push'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// PWA: register the Web Push service worker (secure contexts only; no-op elsewhere).
if (typeof window !== 'undefined' && window.isSecureContext && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    registerPushServiceWorker().catch(() => {})
  })
}

